var map = {
	"./danger-theme.png": 63657,
	"./info-theme.png": 10708,
	"./primary-theme.png": 59432,
	"./secondary-theme.png": 1736,
	"./success-theme.png": 34243,
	"./warning-theme.png": 65022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18825;